module.exports = __webpack_public_path__ + "img/leftArrow.59b0ba3e.png";